import { render, staticRenderFns } from "./indexAbout.vue?vue&type=template&id=b3582220&scoped=true&"
import script from "./indexAbout.vue?vue&type=script&lang=js&"
export * from "./indexAbout.vue?vue&type=script&lang=js&"
import style1 from "./indexAbout.vue?vue&type=style&index=1&id=b3582220&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3582220",
  null
  
)

export default component.exports